import { Component, OnInit } from '@angular/core';
import { OfflineStorageService } from './services/offline-storage.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import * as fromAccountAction from './store/actions/account.action'
import { AccountService } from './services/account.service';
import { autoLogout } from './store/actions/auth.actions';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  getStudenApplication$: Observable<any>;
  studentApplication: any;

  ngUnsubscribe = new Subject<void>()

  title = 'dswdadmin-admin';
  showHeader: boolean = true;

  userProfile: any;

  pageTitle: string = '';

  segment: any;

  constructor(
    private offlineStorageService: OfflineStorageService,
    private router: Router,
    private store: Store<AppState>,
    private accountService: AccountService,
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initializeApp();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setPageTitle(this.route.root);
      });
  }

  async initializeApp(){
    const path = window.location.pathname; 
    this.segment = path.split('/')[1]; 
    const user = await this.offlineStorageService.getObject('user');
    if(user){
      this.store.dispatch(fromAccountAction.getUserProfile());
    }

    window.addEventListener('auth:timeout', async (e: any) => {
      const isTimeout = e?.detail;
      const user = await this.offlineStorageService.getObject('user');
      if (isTimeout) {
        this.authService.autoLogout(this.segment);
      }
    });
  }

  private setPageTitle(route: ActivatedRoute) {
    let activeRoute = route;
    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }
    const title = activeRoute.snapshot.data['title'] || '';
    // this.pageTitleService.setTitle(title);
  }
}
